module.exports = __webpack_public_path__ + "img/AE5008-01.863d43b2.jpg";